export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <p>© 2026 Erik Schmidt</p>
        <a href="#top">
          Back to top <span aria-hidden="true">↑</span>
        </a>
      </div>
    </footer>
  );
}
